import type { CaseStatus } from "./types";

export function money(minor: number | null | undefined, currency = "EUR"): string {
  if (minor == null) return "—";
  return new Intl.NumberFormat("es-ES", { style: "currency", currency }).format(minor / 100);
}

export function date(ts: number | null | undefined): string {
  if (!ts) return "—";
  return new Intl.DateTimeFormat("es-ES", { dateStyle: "medium" }).format(new Date(ts));
}

export function dateTime(ts: number | null | undefined): string {
  if (!ts) return "—";
  return new Intl.DateTimeFormat("es-ES", { dateStyle: "medium", timeStyle: "short" }).format(new Date(ts));
}

export function km(v: number | null | undefined): string {
  if (v == null) return "—";
  return `${new Intl.NumberFormat("es-ES").format(v)} km`;
}

const STATUS_LABELS: Record<CaseStatus, string> = {
  AWAITING_PAYMENT: "Pendiente de pago",
  PAYMENT_CONFIRMED: "Pago confirmado",
  AWAITING_DOCUMENTS: "Esperando documentos",
  DOCUMENTS_UNDER_REVIEW: "Documentos en revisión",
  READY_FOR_INSPECTION: "Listo para inspección",
  INSPECTION_SCHEDULED: "Inspección agendada",
  INSPECTION_IN_PROGRESS: "Inspección en curso",
  REPORT_IN_REVIEW: "Informe en revisión",
  REPORT_READY: "Informe listo",
  COMPLETED: "Completado",
  CANCELLED: "Cancelado",
};

export function statusLabel(s: CaseStatus): string {
  return STATUS_LABELS[s] ?? s;
}

/** Tone for a case status → drives badge colour. */
export function statusTone(s: CaseStatus): "ok" | "warn" | "danger" | "info" | "neutral" {
  if (s === "COMPLETED" || s === "REPORT_READY") return "ok";
  if (s === "CANCELLED") return "danger";
  if (s === "AWAITING_PAYMENT" || s === "AWAITING_DOCUMENTS" || s === "DOCUMENTS_UNDER_REVIEW") return "warn";
  return "info";
}
